<template>
  <div class="container">
    <!-- 保修列表 -->
    <div class="work-order-list" v-for="(item,index) in problemList" :key="index" @click="handleGoPageDetails(item.maintenanceFormId)">
      <div class="work-order-list-type">
        报修类型：{{item.content}}
        <span
          class="work-order-list-status red-color clearfix"
          v-if="item.maintenanceStatus == 0"
        >待处理</span>
        <span class="work-order-list-status yellow-color clearfix" v-if="item.maintenanceStatus == 1">处理中</span>
        <span class="work-order-list-status gray-color clearfix" v-if="item.maintenanceStatus == 2">已关闭</span>
        <span class="work-order-list-status blue-color clearfix" v-if="item.maintenanceStatus == 3">处理完毕</span>
      </div>
      <div class="work-order-list-time">申请时间：{{item.applyDate}}</div>
      <div class="work-order-list-time">网吧：{{item.siteName}}</div>
      <div class="work-order-list-time" v-show="item.maintenanceStatus == 1 || item.maintenanceStatus == 3">处理人：{{item.operationName}}</div>
      <div class="work-order-list-time" v-show="item.maintenanceStatus == 1 || item.maintenanceStatus == 3">处理时间：{{item.applyDate}}</div>
    </div>
  </div>
</template>
<script>
import { processing } from '@/api/workorder'
export default {
  data() {
    return {
      problemList: []
    };
  },
  mounted() {
     this.requesProcessing()
  },
  methods:{
    // 工单处理列表
     requesProcessing() {
        processing().then(res=>{
            this.problemList = res.data
        })
     },
    // 点击跳转详情页
    handleGoPageDetails(maintenanceFormId) {
        this.$router.push({
           path:'/workOrderdetails',
           query:{
             maintenanceFormId:maintenanceFormId
           }
        })
    }
  }
};
</script>
<style lang="scss" scoped>
// $percentage
// 状态颜色处理
.red-color {
  color: #ff3838;
}
.gray-color {
  color: #999999;
}
.yellow-color {
  color: #ffaa00;
}
.blue-color {
  color: #008cff;
}
.container {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-x: hidden;
  &::-webkit-scrollbar {
      display: none;
    }
  // 列表内容
  .work-order-list {
    width: 350px;
    // height: 109px;
    background-color: $white-color;
    margin: 10px 13px;
    border-radius: 8px;
    font-size: 14px;
    text-align: left;
    .work-order-list-type {
      padding: 15px 15px;
      box-sizing: border-box;
      .work-order-list-status {
        text-align: right;
        float: right;
      }
    }
    .work-order-list-time {
      padding: 0 15px;
      padding-bottom: 15px;
      box-sizing: border-box;
    }
    .work-order-list-name {
      padding: 0 15px;
      box-sizing: border-box;
    }
  }
  // 按钮
  .work-order-btn {
    width: 350px;
    height: 44px;
    background: -webkit-linear-gradient(left, #05aefc, #008cff);
    margin: 0 auto;
    border-radius: 22px;
    font-size: 16px;
    color: $white-color;
    line-height: 44px;
    margin: 37px auto;
  }
}
</style>